import { render, staticRenderFns } from "./NencWellbeingHub.vue?vue&type=template&id=21d2f286&scoped=true&"
import script from "./NencWellbeingHub.vue?vue&type=script&lang=ts&"
export * from "./NencWellbeingHub.vue?vue&type=script&lang=ts&"
import style0 from "./NencWellbeingHub.vue?vue&type=style&index=0&id=21d2f286&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2f286",
  null
  
)

export default component.exports